import React, {useEffect, useState} from 'react';
import {Col, Container, Image, OverlayTrigger, Row, Tab, Tabs, Tooltip} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClock, faDatabase, faUser} from "@fortawesome/free-solid-svg-icons";
import MembershipPlans from "./MembershipPlans";
import './VipCenter.css';
import RechargePage from "./RechargePage";
import ExchangeCodes from "./ExchangeCodes";
import LocalDataService from "../../api/LocalDataService";
import moment from "moment";
import {useLocation, useNavigate} from 'react-router-dom';
import ApiService from "../../api/ApiService";
import {toast} from "react-toastify"; // 引入 useLocation
import { formatBeijingTime } from "../../api/TimeService";

const VipCenter = () => {
    const [user, setUser] = useState(null);
    const [activeTab, setActiveTab] = useState("MembershipPlans");
    const location = useLocation(); // 使用 hook 获取 location
    let api = new ApiService();
    const navigate = useNavigate();

    async function updateUserData() {

        const user = await api.get_user_info();
        console.log('Logged in user:', user);
        //更新用户信息
        LocalDataService.set_user_data(user.data);
        // 触发用户状态更新事件
        window.dispatchEvent(new Event('userLoginStatusChanged'));
    }

    useEffect(() => {
        const userData = LocalDataService.load_user_data();
        if (!userData) {
            toast.error('请先登录');
            return navigate("/home");
        }
        setUser(userData);
        updateUserData();
        // 添加事件监听器
        const handleUserLoginStatusChange = () => {
            const userData = LocalDataService.load_user_data();
            setUser(userData);
        };

        window.addEventListener('userLoginStatusChanged', handleUserLoginStatusChange);

        return () => {
            window.removeEventListener('userLoginStatusChanged', handleUserLoginStatusChange);
        };
    }, []);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const tabParam = searchParams.get('tab');
        if (tabParam && ['MembershipPlans', 'PluginsPackages', 'ExchangeCodes'].includes(tabParam)) {
            setActiveTab(tabParam);
        }
    }, [location.search]);

    return (
        <div className="min-vh-100 pt-4 pb-4">
            <Container className="card-container">
                <Row className="align-content-center user-row pt-3 pb-3">
                    <Col lg={2}>
                        <Image
                            src={user && user.user?.avatar ? user.user.avatar : "/images/default_user.svg"}
                            roundedCircle={true}
                            className="user-avatar"/>
                    </Col>

                    <Col lg={8} className="align-content-center">
                        <h5 className="text-lg-start text-center username">{user ? (user?.user?.bindingMobile ? user.user.bindingMobile : '微信用户') : '用户昵称'}</h5>
                        {
                            user && user.vip && (
                                <>
                                    <div className="d-flex flex-column flex-lg-row justify-content-between">
                                        {/*0 非VIP，1 VIP，2 SVIP*/}
                                        {user.vip.level > 0 ? (
                                                <span
                                                    className="member-tag align-self-center">{user.vip.level === 1 ? 'VIP会员' : 'SVIP会员'}</span>)
                                            : (
                                                <span
                                                    className="not-member-tag align-self-center">非会员</span>
                                            )}
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>算力点：用于沸推插件的调用以及网页直接使用智能体单次费用。</Tooltip>}
                                            trigger={["hover", "focus"]}
                                        >
                                            <span className="info-text-highlight">
                                                <FontAwesomeIcon icon={faDatabase} color={'#D38715'}
                                                                 style={{marginRight: '8px'}}/>
                                                ￥{((user?.points?.perpetual) / 100).toFixed(2) || 0.00}
                                            </span>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>免费算力点：通过活动、每日签到等活动获取，每天24点归零，计费优先使用此类算力</Tooltip>}
                                            trigger={["hover", "focus"]}
                                        >
                                            <span className="info-text-highlight" style={{color: '#c6c6c6'}}>
                                                <FontAwesomeIcon icon={faDatabase}
                                                                 style={{marginRight: '8px'}}/>
                                                ￥{((user?.points?.temp) / 100).toFixed(2) || 0.00}
                                            </span>
                                        </OverlayTrigger>
                                        {user.vip.level > 0 && ( <span className="info-text-muted"><FontAwesomeIcon icon={faClock} color={'#02C8E3'} style={{marginRight: '8px'}}/>会员到期时间：{user && user?.vip?.end ? formatBeijingTime(user?.vip?.end) : ''}</span>)}

                                        <span className="info-text-muted">
                                                <FontAwesomeIcon icon={faUser} color={'#02C8E3'}
                                                                 style={{marginRight: '8px'}}/>
                                                ID: {user?.user?.id || ''}
                                            </span>
                                    </div>
                                </>
                            )
                        }

                    </Col>
                </Row>
                <Tabs activeKey={activeTab} onSelect={(key) => setActiveTab(key)} variant={"pills"} navbar={true}
                      navbarScroll={true}
                      className="mb-3 mt-3">
                    <Tab eventKey={'MembershipPlans'} title={"会员计划"}>
                        <MembershipPlans/>
                    </Tab>
                    <Tab eventKey={'PluginsPackages'} title={"算力点"}>
                        <RechargePage/>
                    </Tab>
                    <Tab eventKey={'ExchangeCodes'} title={"兑换码"}>
                        <ExchangeCodes/>
                    </Tab>
                </Tabs>
            </Container>
        </div>
    );
};

export default VipCenter;